import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Modal } from '@grandvisionhq/common';
import { MiniCart } from '../layouts/MiniCart.js';
import { useMiniCartListener } from '../utils/event.js';

var ModalContainer = (_param)=>{
    var { modal  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "modal"
    ]);
    const [lineItems, setLineItems] = React.useState(undefined);
    useMiniCartListener((event)=>{
        if (!lineItems || event.detail.type === 'updated') {
            setLineItems(event.detail.lineItems);
        }
    });
    const handleClose = ()=>{
        setLineItems(undefined);
        (modal === null || modal === void 0 ? void 0 : modal.onModalClose) && modal.onModalClose();
    };
    var ref, ref1;
    return /*#__PURE__*/ React.createElement(Modal, swcHelpers.extends({}, modal, {
        className: classnames('mini-cart-v2', modal === null || modal === void 0 ? void 0 : modal.className),
        "data-t": "mini-cart-v2",
        isOpen: (ref = !!lineItems || (modal === null || modal === void 0 ? void 0 : modal.isOpen)) !== null && ref !== void 0 ? ref : false,
        onModalClose: handleClose,
        showIcon: (ref1 = modal === null || modal === void 0 ? void 0 : modal.showIcon) !== null && ref1 !== void 0 ? ref1 : true
    }), lineItems ? /*#__PURE__*/ React.createElement(MiniCart, swcHelpers.extends({
        lineItems: lineItems
    }, rest)) : null);
};

export { ModalContainer };
//# sourceMappingURL=ModalContainer.js.map
